module.exports = __webpack_public_path__ + "img/Service4.fd075521.svg";